<form class="search-form rounded" [formGroup]="filterModel" (ngSubmit)="doFilter()">
  <input
    id="filter-text"
    type="search"
    name="filterText"
    placeholder="Filter..."
    formControlName="filterText"
    (ngModelChange)="doFilter()"
  />
  <button type="reset" *ngIf="filterIsActive; else submitButton" (click)="reset()">
    <i class="fa-utility fa-semibold fa-xmark"></i>
  </button>
  <ng-template #submitButton>
    <button type="submit"><i class="fa-utility-fill fa-semibold fa-filter"></i></button>
  </ng-template>
</form>
